import { useEffect, useState } from "react";
import { Wallet as WalletIcon, ArrowDownRight, ArrowUpRight, Gift } from "lucide-react";
import { api } from "@/lib/api";
import { Loader } from "@/components/common";

const KIND_LABEL = { drop_entry: "Drop entry", shop_purchase: "Shop purchase", refund: "Refund", grant: "Credit granted", referral: "Referral reward" };

export default function Wallet() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/wallet").then(({ data }) => setData(data)).catch(() => setData(false)); }, []);
  if (data === null) return <Loader />;
  if (data === false) return <div className="text-center py-24 text-slate-400">Could not load wallet.</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-display text-3xl font-black text-white">Store Credit</h1>
      <div className="mt-5 rounded-2xl gold-gradient p-6 text-obsidian relative overflow-hidden gold-glow-lg" data-testid="wallet-balance">
        <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-white/20 blur-2xl" />
        <div className="flex items-center gap-2 font-semibold"><WalletIcon className="w-5 h-5" /> Available balance</div>
        <p className="font-display text-5xl font-black mt-3">${data.balance.toFixed(2)}</p>
        <p className="text-obsidian/70 text-sm mt-2">Spend on drop entries and shop purchases at checkout.</p>
      </div>

      <h2 className="font-display text-lg font-bold text-white mt-8 mb-3">Ledger</h2>
      {data.ledger.length === 0 ? (
        <div className="card-surface rounded-2xl p-10 text-center text-slate-400">No transactions yet.</div>
      ) : (
        <div className="space-y-2" data-testid="wallet-ledger">
          {data.ledger.map((l) => (
            <div key={l.id} className="card-surface rounded-xl p-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${l.amount >= 0 ? "bg-emerald-400/15 text-emerald-400" : "bg-red-400/15 text-red-400"}`}>
                  {l.kind === "grant" ? <Gift className="w-4 h-4" /> : l.amount >= 0 ? <ArrowDownRight className="w-4 h-4" /> : <ArrowUpRight className="w-4 h-4" />}
                </div>
                <div><p className="text-white text-sm font-semibold">{KIND_LABEL[l.kind] || l.kind}</p><p className="text-slate-500 text-xs">{l.description}</p></div>
              </div>
              <span className={`font-mono font-bold ${l.amount >= 0 ? "text-emerald-400" : "text-red-400"}`}>{l.amount >= 0 ? "+" : ""}${l.amount.toFixed(2)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
